import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Card, Container, Stack, SxProps, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useResendVerificationEmailMutation } from '../../api/gql';
import { Logo } from '../../components';
import { LogoutButton } from '../../modules/auth';
import { notify } from '../../utils/notification';
import { useAuth0 } from '@auth0/auth0-react';

export const VerifyYourEmail = () => {
  const { t } = useTranslation();
  const { logout } = useAuth0();
  const { mutate: resendVerificationEmail, isPending } = useResendVerificationEmailMutation({
    onSuccess: (res) => {
      if (res.resendVerificationEmail) {
        notify.neutral({ message: t('verification.resend.success') });
      } else {
        notify.negative({ message: t('verification.resend.error') });
      }
    },
    onError: () => {
      notify.negative({ message: t('verification.resend.error') });
    },
  });

  const onCheckVerification = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Container sx={containerStyles}>
      <Card variant={'outlined'} sx={cardStyles}>
        <Stack direction={'column'} spacing={8}>
          <Stack textAlign={'center'} alignItems={'center'} spacing={1}>
            <Logo width={'40%'} />
            <Typography variant={'h1'} pt={4}>
              {t('verification.verifyEmail')}
            </Typography>
            <Typography variant={'h5'} pt={2}>
              {t('verification.weHaveSentVerificationMail')}
            </Typography>
            <Typography pt={2}>{t('verification.verifyYourMailByClickingOnLink')}</Typography>
          </Stack>
          <Stack direction={'column'} spacing={2}>
            <Button variant={'contained'} size={'large'} onClick={onCheckVerification}>
              {t('verification.success')}
            </Button>
            <LoadingButton fullWidth loading={isPending} onClick={() => resendVerificationEmail({})}>
              {t('verification.resend.info')}
            </LoadingButton>
            <Typography pt={6} textAlign={'center'} variant={'body2'} color={'secondary.300'}>
              {t('verification.otherMeansOfLogin')}
            </Typography>
            <LogoutButton variant={'outlined'} fullWidth />
          </Stack>
        </Stack>
      </Card>
    </Container>
  );
};

const containerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  gap: 4,
};
const cardStyles: SxProps<Theme> = (theme) => ({
  padding: 4,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '60%',
  },
  [theme.breakpoints.up('md')]: {
    width: '45%',
  },
  mb: '15%',
});
